import { Component } from "react";
import mrDraftLogoGif from '../../assets/img/draft_logo2.gif';
import wildCardStyles from "./wildCard.module.css";
class WildCard extends Component {
    render() {
        return (
            <>
                <section className={`mt-navbar ${wildCardStyles.match_screen_height}`}>
                    <div className={`light-bg d-flex justify-content-center py-5 text-dark`}>
                        <div className={`d-flex ${wildCardStyles.mobile_wrapper}`}>
                            <div className={`container ${wildCardStyles.padding_mobile}`}>
                                <h1 class="mt-5 text-uppercase">404 Not Found</h1>
                                <h3 class="fs-4 display-2 fw-bolder text-capitalize">This link you followed may be broken, or page may have been removed.</h3>
                                <div class="mt-5">
                                    <div>
                                        <img src={mrDraftLogoGif} class="img-md img-fluid" alt="Mr-Draft animated logo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default WildCard;